import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { ProductItem } from './product-item';
import { ProductItemSkeleton } from './product-skeleton';

// ----------------------------------------------------------------------

const renderLoading = <ProductItemSkeleton itemCount={20} />;

export function ProductList({ products, loading, loadingMore, searchParams, ...other }) {
  return (
    <>
      <Box
        sx={{
          gap: { sm: 3 },
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
        }}
        {...other}
      >
        {products.map((product) => (
          <ProductItem key={product.id} product={product} searchParams={searchParams} />
        ))}

        {loading && renderLoading}
      </Box>

      {loadingMore && (
        <Box
          className="scroll__snap__child"
          sx={{
            py: 4,
            color: 'common.white',
            justifyContent: 'center',
            display: { xs: 'flex', sm: 'none' },
          }}
        >
          <CircularProgress color="inherit" thickness={1} />
        </Box>
      )}
    </>
  );
}
